export default __webpack_public_path__ + "static/O0103-3f3de8e25ad2d6c7036e8b0d147105f1.png";